import React from 'react';
import { motion } from 'framer-motion';
import { FiTrendingDown } from 'react-icons/fi';
import { useInView } from '../hooks/useInView';
import './WhyItMatters.css';

const WhyItMatters = () => {
  const [ref, isInView] = useInView({ threshold: 0.2, triggerOnce: true });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };

  const badgeVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 15
      }
    }
  };

  return (
    <section className="why-it-matters">
      <motion.div
        ref={ref}
        className="why-container"
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        <motion.h2 variants={textVariants}>Why It Matters</motion.h2>
        
        <motion.p variants={textVariants} className="main-text">
          Every year, billions of paper receipts end up in landfills. Most contain harmful chemicals that prevent recycling.
          Snaply eliminates this waste while making life easier for shoppers and retailers.
        </motion.p>

        <motion.p variants={textVariants} className="secondary-text">
          For businesses, digital receipts mean lower operating costs, better customer data, and measurable sustainability
          progress. For consumers, it's a cleaner wallet and an organized purchase history at your fingertips.
        </motion.p>

        <motion.div
          variants={badgeVariants}
          className="stat-badge"
          whileHover={{
            scale: 1.05,
            boxShadow: '0 15px 35px rgba(16, 185, 129, 0.2)',
            transition: { type: 'spring', stiffness: 300 }
          }}
        >
          <FiTrendingDown className="badge-icon" />
          <span>50% reduction in receipt printing costs</span>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default WhyItMatters;
